/*
 * Apollo link that does the fetching
 * Docs: https://www.apollographql.com/docs/link/links/http.html
 */

import { HttpLink } from 'apollo-link-http';

type FetchOptions = Omit<RequestInit, 'body'> & { body: string };

export const createDirectoryHttpLink = ({
	url,
	getCloudId,
}: {
	url: string;
	getCloudId?: () => string;
}) => {
	const customFetch = async (uri: string, options: FetchOptions) => {
		const body = JSON.parse(options.body);
		const uriWithOps = body.operationName ? `${uri}?q=${body.operationName}` : uri;

		if (body.variables && body.variables._withCloudId && getCloudId) {
			delete body.variables._withCloudId;
			body.variables.cloudId = getCloudId();
			options.body = JSON.stringify(body);
		}

		return fetch(uriWithOps, options);
	};

	return new HttpLink({
		uri: url,
		credentials: 'include',
		fetch: customFetch,
	});
};
